import { useEffect, useRef } from 'react';
import type { AnalyticsEventName } from '@bloom/shared';
import { track, AnalyticsProperties } from '../../lib/analytics';

/**
 * Track a "viewed" event once per mount, when its data has loaded (so it can
 * carry counts). Refetches and re-renders don't repeat it.
 */
export function useTrackWhen(ready: boolean, name: AnalyticsEventName, properties?: AnalyticsProperties) {
  const sent = useRef(false);
  useEffect(() => {
    if (!ready || sent.current) return;
    sent.current = true;
    track(name, properties);
  }, [ready, name, properties]);
}
